// This file was auto-generated by Fern from our API Definition.
export const ChannelSpaceKind = {
    Private: "private",
    Group: "group",
    Topic: "topic",
};
